// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"630":"7cd8fce6","860":"b323cbcf"}[chunkId] + ".chunk.js";
};